var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import * as isoFetch from 'isomorphic-fetch';
import { ClickTracker } from 'bernie-analytics';
import { UitkButton } from 'uitk-react-button';
import { UitkText } from 'uitk-react-text';
import { inject } from 'mobx-react';
import { mergeQueryString } from 'bernie-core';
import { withRouter } from '../../../common/utils/with-router';
var UitkButtonTracked = ClickTracker(UitkButton);
var fetch = isoFetch;
var LocaleSelectorComponent = /** @class */ (function (_super) {
    __extends(LocaleSelectorComponent, _super);
    // `withRouter` requires constructor to be called
    // eslint-disable-next-line no-useless-constructor
    function LocaleSelectorComponent(props) {
        return _super.call(this, props) || this;
    }
    LocaleSelectorComponent.prototype.selectLocale = function (locale, taapSiteTrigger) {
        return __awaiter(this, void 0, void 0, function () {
            var hostname, updateUserUrl, location, queryParams, queryString, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hostname = window.location.href.split('/')[2].split(':')[0];
                        if (!(taapSiteTrigger !== null || taapSiteTrigger !== ' ')) return [3 /*break*/, 2];
                        updateUserUrl = "https://".concat(hostname).concat(taapSiteTrigger, "?newLocale=").concat(locale.locale);
                        return [4 /*yield*/, fetch(updateUserUrl, { method: 'POST' }).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        location = this.props.location;
                        queryParams = {
                            langid: locale.langId
                        };
                        queryString = mergeQueryString(location.search, queryParams);
                        if (window !== undefined) {
                            url = window.location.href && window.location.href.split('?')[0];
                            window.location.href = "".concat(url, "?").concat(queryString);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LocaleSelectorComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, globalComponentsContext = _a.globalComponentsContext, position = _a.position;
        var localeOptions = globalComponentsContext.localeOptions, header = globalComponentsContext.header;
        var fontSize = 300;
        return (!localeOptions || localeOptions.length === 0) ? null : (localeOptions.map(function (locale) {
            var displayLanguage = locale.displayLanguage
                ? (locale.displayLanguage.charAt(0).toUpperCase() + locale.displayLanguage.slice(1))
                : '';
            var onClick = function () { return _this.selectLocale(locale, header.taapSiteTrigger); };
            var localeAbbrev = (locale.locale || '').substr(0, 2).toUpperCase();
            var rfrr = "Picker.PWA.".concat(position, ".").concat(localeAbbrev);
            return (React.createElement(UitkButtonTracked, { key: locale.langId, onClick: onClick, trackImmediate: true, linkName: "Save Language", rfrr: rfrr },
                React.createElement(UitkText, { size: fontSize }, displayLanguage)));
        }));
    };
    LocaleSelectorComponent = __decorate([
        inject('globalComponentsContext')
    ], LocaleSelectorComponent);
    return LocaleSelectorComponent;
}(React.Component));
export var LocaleSelector = withRouter(LocaleSelectorComponent);
//# sourceMappingURL=locale-selector.js.map